import { DurationInputArg2 } from 'moment';

// all flags here, alphabetically sorted
export const ABSOLUTE_TIMEOUT = 'absolute-timeout';
export const APP_VERSION = 'app-version';
export const AUTOMATIONS_IN_CARD_FORM = 'automations-in-card-form';
export const BACK_BUTTON_HISTORY = 'back-button-history';
export const BATCH_UPLOAD_USERS = 'batch-upload-users';
export const BUILDER_FIELDS_LINK = 'builder-fields-link';
export const BUILDER_SUBFORM_LINK = 'builder-subforms-link';
export const CALENDAR_WEEKENDS = 'calendar-weekends';
export const CHECKLIST_IN_LIST_VIEW = 'checklist-in-list-view';
export const CSV_BULK_IMPORT = 'csv-bulk-import';
export const DATA_FRESHNESS = 'data-freshness';
export const DATE_RANGE_COMPONENT = 'date-range-component';
export const DELETE_WORKSPACE_SECTION = 'delete-workspace-section';
export const DEVELOPER_TOOLS = 'developer-tools';
export const DUPLICATE_WORKSPACE_SECTION = 'duplicate-workspace-section';
export const EDITABLE_VIEW_TYPE = 'editable-view-type';
export const INACTIVITY_TIMEOUT = 'inactivity-timeout';
export const MULTIPLE_FILTER_GROUPS = 'multi-filter-groups';
export const ORGANIZATION_TRASH = 'organization-trash';
export const NATIVE_MANAGE_SECTION_MENU = 'native-manage-section-menu';
export const NO_CODE_CREATE_FORM = 'no-code-entity-create-form';
export const NO_CODE_UPDATE_FORM = 'no-code-entity-update-form';
export const PAYWALL_EXPERIMENT = 'paywall-experiment';
export const PERMISSIONS_REFETCH_TIMER = 'permissions-refetch-timer';
export const PM60 = 'endless-preventative-management';
export const REPORTING_UI = 'reporting-ui';
export const SHOW_VIEW_TYPE = 'show-view-type';
export const SUBFORM_GENERATION = 'subform-gen';
export const TIME_TRACKER_COMPONENT_GEOLOCATION = 'time-tracker-component-geolocation';
export const USER_GROUPS = 'user-groups';
export const VIEW_OPTIONS_SUBMENU = 'view-options-submenu';
export const WORKFLOW_SHARING = 'workflow-sharing';
export const WORKFLOW_SHARING_CARD_DATA = 'workflow-sharing-card-data';
export const WORKSPACE_TRASH = 'workspace-trash';

export interface AppVersionFlag {
  version: string;
  frequency: DurationInputArg2; // e.g. 'day', 'week', etc.
}

const appVersionFlagDefault: AppVersionFlag = {
  version: import.meta.env.VITE_VERSION,
  frequency: 'week',
};

// set default flag state here, alphabetically sorted
export const defaultFlags = {
  [ABSOLUTE_TIMEOUT]: 0,
  [APP_VERSION]: appVersionFlagDefault,
  [AUTOMATIONS_IN_CARD_FORM]: false,
  [BACK_BUTTON_HISTORY]: false,
  [BATCH_UPLOAD_USERS]: false,
  [BUILDER_FIELDS_LINK]: false,
  [BUILDER_SUBFORM_LINK]: false,
  [CALENDAR_WEEKENDS]: false,
  [CHECKLIST_IN_LIST_VIEW]: false,
  [CSV_BULK_IMPORT]: false,
  [DATA_FRESHNESS]: {
    enabled: false,
    logPrefix: '',
    maxRetries: 1,
    refetchThrottleMs: 1000,
    sleepDetectorIntervalMs: 1000,
    sleepDetectorTriggerRefetchMs: 1000,
  },
  [DATE_RANGE_COMPONENT]: false,
  [DELETE_WORKSPACE_SECTION]: false,
  [DEVELOPER_TOOLS]: false,
  [DUPLICATE_WORKSPACE_SECTION]: false,
  [EDITABLE_VIEW_TYPE]: false,
  [INACTIVITY_TIMEOUT]: 0,
  [MULTIPLE_FILTER_GROUPS]: false,
  [NATIVE_MANAGE_SECTION_MENU]: false,
  [NO_CODE_CREATE_FORM]: false,
  [NO_CODE_UPDATE_FORM]: false,
  [ORGANIZATION_TRASH]: false,
  [PAYWALL_EXPERIMENT]: '', // redacted or banner
  [PERMISSIONS_REFETCH_TIMER]: 0,
  [PM60]: false,
  [REPORTING_UI]: false,
  [SHOW_VIEW_TYPE]: false,
  [SUBFORM_GENERATION]: false,
  [TIME_TRACKER_COMPONENT_GEOLOCATION]: false,
  [USER_GROUPS]: false,
  [VIEW_OPTIONS_SUBMENU]: false,
  [WORKFLOW_SHARING]: false,
  [WORKFLOW_SHARING_CARD_DATA]: false,
  [WORKSPACE_TRASH]: false,
};

export type Flags = typeof defaultFlags;
export type FlagName = keyof Flags;
